import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader } from 'components/common';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { ValidationTable } from 'components/widgets/ValidationTable/ValidationTable';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { useIsMutating } from 'react-query';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { WholeProjectRowWrapper } from 'components/widgets/WholeProjectRow/wholeProjectRowWrapper';
import { LogicQualityCheckSelectedFilters } from 'components/widgets/LogicQualityCheckSelectedFilter/LogicQualityCheckSelectedFilters';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';
import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';

export const LogicQualityCheckValidationPage = () => {
    const showLoader = useIsMutating(['setCheckerConfigParams']);

    useFullStoryPageView({ pageName: excellenceAppsConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: false });

    return (
        <PageContainer>
            {showLoader ? <OverlayWithSpinner /> : null}
            <HeaderWrapper>
                <TreeProgramTopHeader pageTitle={excellenceAppsConfig.logicQualityCheck.title}>
                    <ShareInsightButton
                        title={excellenceAppsConfig.logicQualityCheck.title}
                        link={window.location.href}
                    />
                    <LogicQualityCheckActionsMenu />
                </TreeProgramTopHeader>
                <Breadcrumbs list={breadcrumbs} />
            </HeaderWrapper>
            <MainContent>
                <LogicQualityCheckSelectedFilters />
                <WholeProjectRowWrapper />
                <ValidationTable />
            </MainContent>
        </PageContainer>
    );
};
